module.exports = __webpack_public_path__ + "img/hand.8c857c3e.png";